/**
 * Human labels for command origins (A-48), as the Output Log and Console show
 * them: "OpenLevel /Roles/Pocket_Gems.level (from Content Browser)".
 */
import type { CommandOrigin } from "./types";

const ORIGIN_LABELS: Record<CommandOrigin, string> = {
  user: "user",
  keyboard: "keyboard",
  toolbar: "Toolbar",
  menu: "menu",
  viewport: "Viewport",
  gizmo: "gizmo",
  outliner: "Outliner",
  inspector: "Inspector",
  preferences: "Preferences",
  contentBrowser: "Content Browser",
  router: "URL",
  tour: "Tour",
  boot: "boot",
  autosave: "autosave",
  replay: "replay",
};

export function originLabel(origin: CommandOrigin): string {
  return ORIGIN_LABELS[origin];
}
